import { Button, ButtonIconPosition, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Card } from "@amzn/stencil-react-components/card";
import { Chip, ChipBackgroundColor, ChipIconPosition, ChipSize } from "@amzn/stencil-react-components/chip";
import { Col, GridItem, Row } from "@amzn/stencil-react-components/layout";
import { H3, Text } from "@amzn/stencil-react-components/text";
import { IconPersonSmall, IconShareSmall, IconShowSmall, IconSparklesSmall } from "@amzn/stencil-react-icons";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export interface TeamSpaceCardData {
  spaceAlias: string;
  title: string;
  description: string;
  owner: string;
  toolCount: number;
  visibility: string;
}

interface TeamSpaceCardProps {
  space: TeamSpaceCardData;
  onNavigate: (alias: string) => void;
}

export const TeamSpaceCard: FC<TeamSpaceCardProps> = ({ space, onNavigate }) => (
  <GridItem lg={6} md={8} sm={4}>
    <Card flexDirection="column" justifyContent="space-between" padding="dimensions.spacing.300">
      <Col gridGap="dimensions.spacing.200">
        <Row justifyContent="space-between" alignItems="flex-start">
          <H3>{space.title}</H3>
          <Row alignItems="center" gridGap="dimensions.spacing.200">
            <Button
              variant={ButtonVariant.Secondary}
              size={ButtonSize.Small}
              icon={<IconShareSmall title="Share" />}
              iconPosition={ButtonIconPosition.Trailing}
            >
              {getString("spaces.card.share")}
            </Button>
            <Button
              variant={ButtonVariant.Secondary}
              size={ButtonSize.Small}
              onClick={() => onNavigate(space.spaceAlias)}
              data-testid="learn-more-btn"
            >
              {getString("spaces.card.learnMore")}
            </Button>
          </Row>
        </Row>
        <Row alignItems="center" gridGap="dimensions.spacing.200" flexWrap="wrap">
          <Chip
            size={ChipSize.Small}
            icon={<IconSparklesSmall />}
            iconPosition={ChipIconPosition.Leading}
            backgroundColor={ChipBackgroundColor.Blue}
          >
            {getString("spaces.page.tools", { count: String(space.toolCount) })}
          </Chip>
          <Chip
            size={ChipSize.Small}
            icon={<IconShowSmall />}
            iconPosition={ChipIconPosition.Leading}
            backgroundColor={ChipBackgroundColor.Green}
          >
            {space.visibility}
          </Chip>
          <Chip
            size={ChipSize.Small}
            icon={<IconPersonSmall />}
            iconPosition={ChipIconPosition.Leading}
            backgroundColor={ChipBackgroundColor.Purple}
          >
            {getString("spaces.page.owner", { name: space.owner })}
          </Chip>
        </Row>
        <Text color="color.text.secondary">{space.description}</Text>
      </Col>
    </Card>
  </GridItem>
);
